import React from 'react';
import Box from '@mui/material/Box';

// Uses the actual brand asset (public/logo2.png — the real "CHEERS 2 NIGHT" glitter-gold
// wordmark, carried over from the legacy app's common/img/logo2.png) instead of a recreated
// text wordmark. The "ROYAL PEOPLE ROYAL CHOICE" tagline is already baked into the image itself
// (visible on close inspection), so it isn't re-rendered as separate text here.
const Logo: React.FC<{ size?: 'small' | 'large' }> = ({ size = 'small' }) => {
  const width = size === 'large' ? 260 : 150;

  return (
    <Box
      component="img"
      src={`${process.env.PUBLIC_URL}/logo2.png`}
      alt="Cheers2Night — Royal People Royal Choice"
      sx={{ width, height: 'auto', display: 'block', mx: size === 'large' ? 'auto' : 0 }}
    />
  );
};

export default Logo;
